var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodereview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.987,
    height: 45.867,
    viewBox: "0 0 51.987 45.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.411,192.164a.855.855,0,0,1-.556-.2L115.3,187.23a.859.859,0,0,1,0-1.307l5.554-4.729a.858.858,0,1,1,1.113,1.307l-4.786,4.076,4.786,4.076a.859.859,0,0,1-.557,1.512Zm0,0",
    transform: "translate(-100.9 -158.798)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.566,192.164a.859.859,0,0,1-.557-1.512l4.786-4.076-4.786-4.076a.858.858,0,0,1,1.113-1.307l5.554,4.729a.859.859,0,0,1,0,1.307l-5.554,4.729A.855.855,0,0,1,250.566,192.164Zm0,0",
    transform: "translate(-219.091 -158.797)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.814,171.176a.873.873,0,0,1-.178-.019.859.859,0,0,1-.663-1.017l3.461-16.434a.858.858,0,0,1,1.68.354l-3.461,16.434A.858.858,0,0,1,189.814,171.176Zm0,0",
    transform: "translate(-165.786 -134.262)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.224,45.867H5.763A5.769,5.769,0,0,1,0,40.1V5.763A5.77,5.77,0,0,1,5.763,0H46.224a5.77,5.77,0,0,1,5.763,5.763V40.1A5.769,5.769,0,0,1,46.224,45.867ZM5.763,1.717A4.051,4.051,0,0,0,1.717,5.763V40.1A4.051,4.051,0,0,0,5.763,44.15H46.224A4.051,4.051,0,0,0,50.27,40.1V5.763a4.051,4.051,0,0,0-4.046-4.046Zm0,0",
    transform: "translate(0 0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.129,99.807H.858a.858.858,0,0,1,0-1.717h50.27a.858.858,0,0,1,0,1.717Zm0,0",
    transform: "translate(0 -86.063)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.166,39.721a2.716,2.716,0,1,1,2.716-2.716A2.72,2.72,0,0,1,100.166,39.721Zm0-3.716a1,1,0,1,0,1,1A1,1,0,0,0,100.166,36.006Zm0,0",
    transform: "translate(-85.501 -30.085)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1,39.507a2.716,2.716,0,1,1,2.716-2.716A2.719,2.719,0,0,1,32.1,39.507Zm0-3.716a1,1,0,1,0,1,1A1,1,0,0,0,32.1,35.791Zm0,0",
    transform: "translate(-25.784 -29.896)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.231,39.936a2.716,2.716,0,1,1,2.716-2.716A2.719,2.719,0,0,1,168.231,39.936Zm0-3.716a1,1,0,1,0,1,1A1,1,0,0,0,168.231,36.22Zm0,0",
    transform: "translate(-145.222 -30.273)",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodereview);
export default __webpack_public_path__ + "static/media/codereview.be927170.svg";
export { ForwardRef as ReactComponent };